import React, { useMemo } from "react";
import { fourPlaceHolder, getFormattedDate } from "modules/utilities/utility";
import _ from "lodash";
import { Tag } from "antd";
import AdvanceTableWrapper from "modules/common/advance-table/AdvanceTableWrapper";
import AdvanceTable from "modules/common/advance-table/AdvanceTable";
import { Link } from "react-router-dom";
import NoData from "assets/svgs/no_data/NoData";

function PrescribedTable({ prescriptionData, prescriptionLoading }) {

  const tableData = useMemo(() => {
    return (prescriptionData?.data || []).map((item) => ({
      name: _.get(item, ["order", "case", "user", "first_name"], ""),
      order_display_id: _.get(item, ["order", "order_display_id"], ""),
      order_meta: _.get(item, ["order", "order_meta", "line_items"], ""),
      order_count: _.get(item, ["order", "count"], ""),
      order_status: _.get(item, ["order", "status"], ""),
      order_created_at: getFormattedDate(
        _.get(item, ["order", "created_at"], "")
      ),
      caseId :_.get(item,"order.case_id","") ,
      created_at: getFormattedDate(_.get(item, ["created_at"], "")),
    }));
  }, [prescriptionData?.data]);

  const columns = [
    {
      Header: "Name",
      accessor: "name",
      key: "name",
      Cell: (rowData) => {
        return (
          <Link to={`/lead-details/${rowData.row.original.caseId}`}>
          {rowData.row.original.name}
          </Link>
        );
      },
    },
    {
      Header: "OrderId",
      accessor: "order_display_id",
      key: "order_display_id",
    },
    {
      Header: "Order Name",
      key: "New/Repeat",
      accessor: "order_count",
      width: "35%",
      Cell: (rowData) => {
        return (
          <div className="text-break text-wrap">
            {rowData.row.original.order_meta.map((item, index) => (
              <span key={index}>
                {item.name} {item.quantity}/
              </span>
            ))}
          </div>
        );
      },
    },
    {
      Header: "New/Repeat",
      key: "order_count",
      accessor: "New/Repeat",
      Cell: (rowData) => {
        let orderCount = rowData.row.original.order_count;
        return (
          <>
            {orderCount <= 1 ? (
              <Tag color="blue">New</Tag>
            ) : (
              <Tag color="cyan">Repeat {orderCount}</Tag>
            )}
          </>
        );
      },
    },
    {
      Header: "Order Status",
      accessor: "order_status",
      key: "order_status",
    },
    {
      Header: "Order Date",
      accessor: "order_created_at",
      key: "order_created_at",
    },
    {
      Header: "Assigned On",
      accessor: "created_at",
      key: "created_At",
    },
  ];

  return (
    <div style={{ maxHeight: "700px", overflowY: "auto" }}>
      {prescriptionLoading?fourPlaceHolder():tableData?.length ?(
        tableData?.length&&<AdvanceTableWrapper columns={columns} data={tableData} sortable>
          <AdvanceTable
            table
            headerClassName="bg-200 text-nowrap align-middle"
            rowClassName="align-middle white-space-nowrap"
            tableProps={{
              bordered: true,
              striped: true,
              className: "fs-10 mb-0 overflow-hidden",
            }}
          />
        </AdvanceTableWrapper>
      ):<div className="border p-2 rounded text-center f-2 font-poppins">Data is not available <NoData/></div>}
    </div>
  );
}

export default PrescribedTable;
